export const penaltySteps = [
  {
    id: 'step1',
    title: 'Step 1: Navigate to Penalties',
    page: 'Penalties',
    content: [
      'Click "Penalties" in the sidebar under the Payroll group.',
      'The page shows four status cards (Pending, Acknowledged, Deducted, Waived) with counts and amounts.',
      'Below that: a Repeat Shortcomings strip (employees with 2+ penalties), search, status filter, and the penalties table.',
    ],
    note: 'Penalties is visible to Super Admins, Admins and LOP Managers.',
  },
  {
    id: 'step2',
    title: 'Step 2: Set Up the Zoho Form Intake',
    page: 'Zoho Integration',
    content: [
      'Go to Zoho Integration → click "Add Form" and give it a name (e.g. "Employee Penalty Form").',
      'Copy the generated Webhook URL.',
      'In Zoho Forms, open your penalty form → Integrations → Webhooks → paste the URL and enable it.',
    ],
    details: [
      { label: 'Recommended fields', desc: 'Employee Code, Employee Email, Incident Date, Category, Subcategory, Severity (Minor/Moderate/Major), Amount, Description, Referrer Name, Reporter Email, Action, Internal Notes.' },
    ],
    note: 'Severity choices in Zoho must be exactly Minor, Moderate or Major — anything else defaults to Minor.',
  },
  {
    id: 'step3',
    title: 'Step 3: Send a Test Submission',
    page: 'Zoho Integration',
    content: [
      'Submit a test entry from your Zoho form (Zoho\'s "Test Webhook" also works).',
      'The app receives the payload and auto-detects every field name.',
      'Open your form in Zoho Integration — the "Detected fields" count updates and each field appears in the Field Mapping tab.',
    ],
    note: 'Every submission (mapped or not) is always stored under the form\'s Submissions tab, so no data is ever lost.',
  },
  {
    id: 'step4',
    title: 'Step 4: Map Fields & Activate',
    page: 'Zoho Integration → Field Mapping',
    content: [
      'Open the Field Mapping tab of your form.',
      'Set Target Module to "penalties" — the available app fields appear as hints.',
      'Type the app field name next to each Zoho field you want to capture.',
      'Toggle the form to Active and click "Save Mapping".',
    ],
    details: [
      { label: 'employee_code', desc: 'Employee ID/code — primary way to match the employee.' },
      { label: 'employee_email', desc: 'Fallback match if no code — must equal the employee\'s email in PayTrack.' },
      { label: 'amount', desc: 'Penalty amount. Currency strings like "₹1,500" are parsed automatically.' },
      { label: 'category / subcategory / severity', desc: 'Shortcoming classification shown on the Penalties table.' },
      { label: 'reported_by / reporter_email / action / internal_notes', desc: 'Optional context fields stored on the record.' },
    ],
    important: 'Metadata fields (Added time, IP address, Added email ID, Attachments, Deduct-from-salary choice) can be left unmapped — deduction is always a manual, controlled action inside PayTrack.',
  },
  {
    id: 'step5',
    title: 'Step 5: Record a Manual Penalty',
    page: 'Penalties',
    content: [
      'Click "Record Penalty" (top-right) for incidents that did not come through Zoho.',
      'Select the employee, incident date, category, severity, amount, description and reporter.',
      'The record is created with status Pending and source "Manual".',
    ],
  },
  {
    id: 'step6',
    title: 'Step 6: Review & Acknowledge',
    page: 'Penalties',
    content: [
      'New penalties arrive as Pending.',
      'Use the ⋯ menu → "Acknowledge" once the incident has been reviewed with the employee.',
      'The Occurrence column (e.g. "2×") shows how many non-waived penalties the employee has — repeat offenders are also highlighted in the red strip at the top.',
    ],
    note: 'Statuses flow: Pending → Acknowledged → Deducted or Waived.',
  },
  {
    id: 'step7',
    title: 'Step 7: Deduct from Salary',
    page: 'Penalties → Salary Entry',
    content: [
      'Use the ⋯ menu → "Deduct from Salary" on a pending/acknowledged penalty.',
      'Pick the salary month and year — the penalty amount is added to that month\'s Recovery Amount (reason: Penalty) and the Bank Transfer updates instantly.',
      'Alternatively, use "Deduct from Incentive" (Super Admin/Admin only) — bookkeeping only: the penalty is marked as deducted from the chosen month\'s incentive, but salary entry numbers are NOT changed.',
      'The penalty becomes Deducted and the Status column shows "Salary · Month Year" or "Incentive · Month Year".',
    ],
    details: [
      { label: 'Who can deduct', desc: 'Super Admin, Admin and Payroll Auditor only. LOP Managers can record and waive but never touch salary.' },
      { label: 'Locks', desc: 'Paid or finalized salary records cannot be modified (Super Admin override for finalized). A salary entry must exist for the chosen month.' },
      { label: 'Formula', desc: 'Bank Transfer = Net Payable − Income Tax − Recovery (which now includes the penalty).' },
      { label: 'Revert', desc: 'Made a mistake? ⋯ menu → "Revert Deduction" (Super Admin / Admin only, reason mandatory). The recovery and bank transfer are restored and the penalty returns to Pending, ready to re-deduct to the correct month.' },
    ],
    important: 'Deducted penalties are locked — they cannot be edited or deleted. Use Revert Deduction to safely undo a wrong deduction.',
  },
  {
    id: 'step8',
    title: 'Step 8: Waive, Edit or Delete',
    page: 'Penalties',
    content: [
      'Waive: ⋯ menu → "Waive" with an optional reason — the penalty is kept for history but never deducted and excluded from occurrence counts.',
      'Edit: update date, category, severity, amount, description or reporter while the penalty is not yet deducted.',
      'Delete: allowed for pending/acknowledged/waived penalties. Deducted penalties cannot be deleted.',
    ],
    note: 'The full original Zoho payload for any penalty remains auditable under Zoho Integration → your form → Submissions.',
  },
];
